<template>
  <div :class="['text-input',classField]">
    <label :for="'text-'+uuid" class="subtitle-2 black--text pl-3">
      {{field.label}}
      <span v-if="this.field.required==1" class="orange--text text--darken-3">*</span>
    </label>
    <v-text-field
      v-model="model"
      @change="update()"
      :id="'text-'+uuid"
      :placeholder="field.config.placeholder"
      type="text"
      :error-messages="block.errorMessages"
      class="pt-1"
      :hide-details="true"
    />
    <div class="hint" v-if="field.hint">{{field.hint}}</div>
  </div>
</template>

<script>
import FieldMixin from "./FieldMixin";
export default {
  mixins: [FieldMixin],
  name: "FieldText",

  methods: {
    validate: function() {
      this.errorMessages = [];
      if (this.field.required === 1 && !this.model) {
        this.isValid = false;
        this.addError(this.block.id,"Champ obligatoire");
      } else {
        this.isValid = true;
      }
    }
  }
};
</script>

<style lang="less" scoped>
.text-input {
  /deep/ .v-text-field__slot {
    border-color: #e8e8e8;
    background-color: #e8e8e8;
  }
  /deep/ .v-text-field input {
    padding: 3px 0;
  }
}
</style>
